import actionTypes from '../constants/action-types';

const paymentURL = (state = null, action) => {
  if (action.type !== actionTypes.SET_PAYMENT_URL) return state;

  return action.payload.url;
};

export default paymentURL;
